import Actions from '../../odata/actions';

const actions = new Actions('cartonSymbol', 'cartonSymbols');

export default actions;
